const testimonials = [
    {
        name: 'Destiny',
        role: 'CEO, Acme Corp',
        text: 'SimpliTechs delivered our project on time and exceeded expectations! Their attention to detail and professionalism made the process seamless.',
        avatar: 'https://api.dicebear.com/9.x/avataaars/svg?seed=Destiny',
        rating: 5,
    },
    {
        name: 'Alex',
        role: 'Product Manager, InnovateX',
        text: 'Professional, creative, and reliable team. Highly recommended for any digital project. The results were outstanding.',
        avatar: 'https://api.dicebear.com/9.x/avataaars/svg?seed=Alex',
        rating: 5,
    },
    {
        name: 'Jordan',
        role: 'CTO, NextGen Solutions',
        text: 'Great communication and top-notch results. The team was always available and delivered exactly what we needed.',
        avatar: 'https://api.dicebear.com/9.x/avataaars/svg?seed=Jordan',
        rating: 4,
    },
    {
        name: 'Morgan',
        role: 'Marketing Lead, BrightIdeas',
        text: 'SimpliTechs brought our vision to life with creativity and technical expertise. We loved working with them!',
        avatar: 'https://api.dicebear.com/9.x/avataaars/svg?seed=Morgan',
        rating: 5,
    },
    {
        name: 'Taylor',
        role: 'Founder, StartUp Hub',
        text: 'From start to finish, the process was smooth and the results were fantastic. Will definitely work with SimpliTechs again.',
        avatar: 'https://api.dicebear.com/9.x/avataaars/svg?seed=Taylor',
        rating: 5,
    },
];

export default testimonials; 